import * as React from 'react';
import { StylesProps, ThemeType } from '../../../theme/jss-types';
import { singleConsignmentStyles } from '../single-consignment.styles';
import withStyles from 'react-jss';
import { ReduxStore } from 'reducers/redux.types';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import Cross from '../../../assets/cross';
import { omitBy, groupBy } from 'lodash';
import { formRules } from 'library/constants';
import {
    CheckCircleFilled,
    ExclamationCircleFilled,
    LeftOutlined,
    RightOutlined,
} from '@ant-design/icons';
import {
    ButtonNames,
    CreateActions,
    formFields,
    validationBuilderFieldMapping,
    SECTION_NAMES,
    fieldNameToKeysMapping,
    addressTypes,
    addressFields,
} from '../create-modal.constants';
import {
    ButtonAction,
} from '../create-consignment.types';
import {
    Button,
    Drawer,
    Form,
    Modal,
    Row,
    message,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { getFormFieldFromMapping, ifFieldExistsInMapping } from './components/generic-field-renderer';
import {
    createConsignment,
    getContentList,
    getCurrencyCodes,
    getIncoTerms,
    getPudoHubs,
    getValidationData,
    fetchItemUnits,
    isProductCodeMasterActive,
} from 'network/consignments.api';
import { Category, Commodity, PudoHubs } from 'library/Types';
import Loader from 'components/common/Loader';
import { getCountries, getUploadFileUrls, uploadImageToS3 } from 'network/common.api';
import { getLoadType } from 'network/pickup.api';
import {
    convertToAPIBodySaveSingle,
    internationalFields, isEmptyValue, nonDocumentFields,
}
    from './single-consignment-helper';
import sift from 'sift';
import { getPurchaseOrderDetails } from 'network/purchase.api';
import SummaryStep from '../single-consignment-steps/summary-step';
import { Master } from 'types/master-data-types';
import { getCurrentCustomer } from 'components/common/utils';

const lodash = require('lodash');

const intKeys = [
    'length',
    'width',
    'height',
    'cod_amount',
    'cop_amount',
    'weight',
    'destination_details.latitude',
    'destination_details.longitude',
    'return_details.latitude',
    'return_details.longitude',
    'origin_details.latitude',
    'origin_details.longitude',
    'alternate_delivery_details_1.latitude',
    'alternate_delivery_details_1.longitude',
    'alternate_delivery_details_2.latitude',
    'alternate_delivery_details_2.longitude',
    'redirection_address.latitude',
    'redirection_address.longitude',
    'declared_value',
    'num_pieces',
    'freight_cost',
    'fob_value',
    'total_gst_paid_amount',
    'invoice_amount',
    'customs_value.amount',
];
const pieceLevelIntKeys = [
    'quantity',
    'weight',
    'length',
    'width',
    'height',
    'codAmount',
];
type DataInputType = Record<string, any>;
type ReferenceObjectType =Record<string, any>;

interface SingleConsignmentProps extends StylesProps<ReturnType<typeof singleConsignmentStyles>>,
    ReturnType<typeof mapStateToProps> {
    // config: any;
    onClose: () => void;
    setSuccess: (data: any) => void;
    loadconsignments: () => void;
    // isRTL: any;
    uiTheme: ThemeType;
    editData?: any;
    formLayoutConfig: any;
    actionType?: any;
    shipmentPurposeList: any;
    subLayout: any;
    customFieldsList: any;
    pickup_schedule_creation: boolean;
    show_product_code_dropdown: boolean;
    master: Master;
    enableServiceability: boolean;
}

interface DocumentDetailsUploadPayload {
    type: string;
    url: string;
}

const SingleConsignment = (props: SingleConsignmentProps) => {
    const {
        // config,
        classes,
        onClose,
        // isRTL,
        uiTheme,
        editData,
        formLayoutConfig,
        mandatoryFieldNonDocIntl,
        mandatoryFieldShipmentCommercial,
        mandatoryPieceDetails,
        showRiskSurchargeType,
        loadconsignments,
        showInvoiceOptions,
        setSuccess,
        useCategory,
        actionType,
        shipmentPurposeList,
        subLayout,
        customFieldsList,
        pickup_schedule_creation,
        show_product_code_dropdown,
        autoCalculateDetails,
        master,
        enableServiceability,
        validatePiecePurchaseOrder,
    } = props;
    const { t, i18n } = useTranslation();

    const [form] = Form.useForm();

    const [closeConfirm, setCloseConfirm] = React.useState<boolean>(false);
    const [visited, setVisited] = React.useState<{[key: number]: boolean | undefined | null}>({});
    const [currentTabIndex, setCurrentTabIndex] = React.useState(0);
    const [creating, setCreating] = React.useState<boolean>(false);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [childClients, setChildClients] = React.useState<any>([]);
    const [pudoHubs, setPudoHubs] = React.useState<PudoHubs[]>([]);
    const [contentList, setContentList] = React.useState<Commodity[]>([]); // old
    const [categoryList, setCategoryList] = React.useState<Category[]>([]); // new
    const [itemUnits, setItemUnits] = React.useState<any[]>([]);
    const [numberPieces, setNumberPieces] = React.useState<number>(1);
    const [currencyList, setCurrencyList] = React.useState<any[]>([]);
    const [countryList, setCountryList] = React.useState<any[]>([]);
    const [manufacturingCountryList, setManufacturingCountryList] = React.useState<any[]>([]);
    const [incotermsList, setIncotermsList] = React.useState<any>([]);
    const [loadType, setLoadType] = React.useState<any>([]);
    const [validationData, setValidationData] = React.useState<any>([]);
    const [validationBuilderKeysMapping, setValidationBuilderKeysMapping] = React.useState<any>([]);
    const [formLayout, setFormLayout] = React.useState<any>(formLayoutConfig);
    const [creatingAddress, setCreatingAddress] = React.useState<boolean>(false);
    const [productCodeActive, setProductCodeActive] = React.useState<boolean>(false);
    const [productCodeLists, setProductCodeLists] = React.useState<any[]>([]);
    const [productHsCodeMapping, setProductHsCodeMapping] = React.useState<Record<number, Record<string, string>>>({});
    const [addressErrors, setAddressErrors] = React.useState<any>({});
    const [disabledFields, setDisabledFields] = React.useState<any>({});

    const { ConsignmentCategory, ItemType } = formFields;
    const consignmentCategory = Form.useWatch(ConsignmentCategory.key, form);
    const courierType = Form.useWatch('courierType', form);
    const itemType = Form.useWatch(ItemType.key, form);

    const addCustomFieldsToValidationBuilderMapping = () => {
        const customFieldsKeys: string[] = customFieldsList?.map((item: any) => ({ [item.id]: item.id }));
        const customFieldsKeysObject = customFieldsKeys?.reduce((acc, obj: any) => ({ ...acc, ...obj }), {});
        setValidationBuilderKeysMapping({ ...validationBuilderFieldMapping, ...customFieldsKeysObject });
    };

    React.useEffect(() => {
        if (formLayoutConfig?.length) {
            setFormLayout([...formLayoutConfig, { prettyName: 'summary' }]);
        }
    }, [formLayoutConfig]);

    React.useEffect(() => {
        setVisited({
            ...visited,
            [currentTabIndex]: true,
        });
        addCustomFieldsToValidationBuilderMapping();
    }, [currentTabIndex]);

    const loadValidationData = async () => {
        const result = await getValidationData('consignment_softdata_validation');
        setValidationData(result?.data?.validations || []);
    };

    const checkForPieceField = (layout: any) => {
        return layout?.some((section: any) => section?.sections?.some(
            (subSection: any) => subSection?.fieldsList?.includes('piece'),
        ));
    };

    const isPieceEnabled = checkForPieceField(formLayout);
    const isCodFieldPresent = formLayout?.some((layout: any) => layout.sections?.some(
        (section: any) => section.fieldsList?.includes('isCOD'),
    ));

    const loadAccounts = async () => {
        const result = getCurrentCustomer(master?.children_list);
        setChildClients(result || []);
        const customer = result?.length ? result[0] : undefined;
        form.setFieldsValue({
            [formFields.SubAccount.key]: form.getFieldValue(formFields.SubAccount.key)
                || `${customer.customer_code}+${customer.customer_id}+${customer.customer_name}`,
        });
    };

    const loadPudoHubs = async () => {
        const response = await getPudoHubs();
        setPudoHubs(response?.data || []);
    };

    const loadContents = async () => {
        const response = await getContentList({
            isInternational: false,
            useCommodityCategory: useCategory,
        });
        if (useCategory) {
            setCategoryList(response?.data);
        } else {
            setContentList(response?.data);
        }
    };

    const loadItemUnits = async () => {
        setLoading(true);
        const response = await fetchItemUnits();
        if (response?.data?.length) {
            const data = response?.data || [];
            const itemUnitsToSet = data.map((entry:any) => {
                return {
                    label: entry?.name,
                    value: entry?.code,
                };
            });
            setItemUnits(itemUnitsToSet);
        }
        setLoading(false);
    };

    const checkProductCodeMasterActive = async () => {
        setLoading(true);
        const response = await isProductCodeMasterActive();
        if (response.isSuccess) {
            setProductCodeActive(response?.data?.is_product_code_master_active);
        }
        setLoading(false);
    };

    const loadCurrencyCodes = async () => {
        const response = await getCurrencyCodes();
        setCurrencyList(response?.data);
    };

    const loadCountries = async () => {
        const countriesResponse = await getCountries();
        if (countriesResponse.isSuccess) {
            setCountryList(countriesResponse.data.map((obj: any) => {
                return {
                    value: obj.country,
                    label: obj.country,
                };
            }));
            setManufacturingCountryList(
                countriesResponse?.data?.map((obj: any) => {
                    return {
                        value: obj?.country_code,
                        label: obj?.country,
                    };
                }).sort((a: any, b: any) => a?.label?.localeCompare(b?.label)),
            );
        }
    };

    const isDisabledNumPiece = () => {
        if (isPieceEnabled) {
            return true;
        }
        return (consignmentCategory === 'international' && autoCalculateDetails);
    };

    const fetchPoDetails = async (referenceNumber: string, index: number) => {
        const response = await getPurchaseOrderDetails({
            referenceNumber,
        });
        if (response.isSuccess) {
            const pieces = response.data?.pieces_detail || [];
            const activePieces = pieces?.filter((piece: any) => piece?.status === 'Open') || [];
            const mapping : Record<string, string> = {};
            activePieces?.forEach((piece: any) => {
                if (!mapping[piece?.product_code]) {
                    mapping[piece?.product_code] = piece?.hs_code;
                }
            });

            setProductHsCodeMapping((prevMapping: any) => ({
                ...(prevMapping || {}),
                [index]: mapping,
            }));

            const unique = Array.from(new Set(activePieces?.map((piece: any) => piece.product_code)));
            const newProductCodeLists = [...productCodeLists];
            newProductCodeLists[index] = unique;
            setProductCodeLists(newProductCodeLists);
        } else {
            message.error(response.errorMessage);
        }
    };

    const resetProductCode = (index: number) => {
        const newProductCodeLists = [...productCodeLists];
        newProductCodeLists[index] = [];
        setProductCodeLists(newProductCodeLists);
        form.setFieldsValue({
            [`pieceProductCode_${index}`]: undefined,
            [`hsCode_${index}`]: undefined,
        });
    };

    const placeholderNumPieces = () => {
        if (isPieceEnabled) {
            return ('1');
        }
        return t('num_pieces_label');
    };

    const loadIncoterms = async () => {
        const response = await getIncoTerms();
        if (!response.isSuccess) {
            message.error(response.errorMessage);
        } else {
            setIncotermsList(
                response?.data.map((incoTerm: any) => {
                    return {
                        label: incoTerm,
                        value: incoTerm,
                    };
                }),
            );
        }
    };

    const loadLoadTypeList = async () => {
        const response = await getLoadType();
        setLoadType(response?.data || []);
    };

    const loadData = async () => {
        setLoading(true);
        await Promise.all([
            checkProductCodeMasterActive(),
            loadAccounts(),
            loadPudoHubs(),
            loadContents(),
            loadCurrencyCodes(),
            loadCountries(),
            loadIncoterms(),
            loadLoadTypeList(),
            loadValidationData(),
            loadItemUnits(),
        ]);
        setLoading(false);
    };

    React.useEffect(() => {
        loadData();
    }, []);

    function flattenObject(obj: any, parentKey = '') {
        return Object.keys(obj).reduce((acc, key) => {
            const prefixedKey = parentKey ? `${parentKey}.${key}` : key;
            if (typeof obj[key] === 'object' && !Array.isArray(obj[key]) && obj[key] !== null) {
                // Recursively flatten nested objects
                Object.assign(acc, flattenObject(obj[key], prefixedKey));
            } else {
                // Add the flattened key-value pair to the accumulator
                acc[prefixedKey] = obj[key];
            }
            return acc;
        }, {} as any);
    }

    function unflattenObject(flatObj: any) {
        const unflatten = (obj: any) => {
            const result = {};
            const objKeys = Object.keys(obj);
            objKeys.forEach((key) => {
                const keys = key.split('.');
                let nestedObj: any = result;
                for (let i = 0; i < keys.length - 1; i += 1) {
                    const nestedKey = keys[i];
                    if (!(nestedKey in nestedObj)) {
                        nestedObj[nestedKey] = {};
                    }
                    nestedObj = nestedObj[nestedKey];
                }
                nestedObj[keys[keys.length - 1]] = obj[key];
            });
            return result;
        };

        return unflatten(flatObj);
    }
    const replaceReferenceInObject = (obj: any, refObj: DataInputType): any => {
        if (!obj || typeof obj !== 'object') {
            return obj;
        }
        if (Array.isArray(obj)) {
            return obj.map((value) => {
                if (value && typeof value === 'object' && value.$reference) {
                    const path = value.$reference;
                    return lodash.get(refObj, path);
                }
                return replaceReferenceInObject(value, refObj);
            });
        }
        const result = { ...obj };
        Object.keys(obj).forEach((key) => {
            const value = obj[key];
            if (value && typeof value === 'object' && value.$reference) {
                const path = value.$reference;
                const valueToSet = lodash.get(refObj, path);
                result[key] = valueToSet;
            } else {
                result[key] = replaceReferenceInObject(value, refObj);
            }
        });
        return result;
    };

    const getPiecesDetail = (data: any) => {
        const piecesDetail = [];
        for (let i = 0; i < numberPieces; i += 1) { // add each key to validationBuilderFieldMapping
            piecesDetail.push({
                reference_number: data[`reference_number_${i}`],
                description: data[`description_${i}`],
                length: data[`length_${i}`],
                width: data[`width_${i}`],
                weight: data[`weight_${i}`],
                height: data[`height_${i}`],
                unit: data[`unit_${i}`],
                weightUnit: data[`weightUnit_${i}`],
                quantity: data[`quantity_${i}`],
                codAmount: data[`codAmount_${i}`],
                purchaseOrderNumber: data[`purchaseOrderNumber_${i}`],
                eccn: data[`eccn_${i}`],
                isKit: data[`isKit_${i}`] === 'yes',
                hsCode: data[`hsCode_${i}`],
                hsnCode: data[`hsCode_${i}`],
                iossNumber: data[`iossCode_${i}`],
                pieceProductCode: data[`pieceProductCode_${i}`],
                manufacturingCountry: data[`manufacturingCountry_${i}`],
                isDangerousGood: data[`isDangerousGood_${i}`] === 'true',
                dangerousGoodAccessible: data[`dangerousGoodAccessible_${i}`] === 'true',
                dangerousGoodUnNumber: data[`dangerousGoodUnNumber_${i}`],
                dangerousGoodClass: data[`dangerousGoodClass_${i}`],
                dangerousGoodName: data[`dangerousGoodName_${i}`],
                dangerousGoodDivision: data[`dangerousGoodDivision_${i}`],
                dangerousGoodPackingGroup: data[`dangerousGoodPackingGroup_${i}`],
                dangerousGoodCategory: data[`dangerousGoodCategory_${i}`],
                dangerousGoodCategoryType: data[`dangerousGoodCategoryType_${i}`],
                dangerousGoodCategoryPackingInstruction: data[`dangerousGoodCategoryPackingInstruction_${i}`],
                declaredValue: data[`declaredValue_${i}`],
                declaredCurrency: data[`declaredCurrency_${i}`],
                totalTax: data[`taxDetailsTotalTax_${i}`],
                taxPercentage: data[`taxDetailsTaxPercentage_${i}`],
                piecesItemDetails: data[`piecesItem_${i}`],
                meisApplicable: data[`meis_${i}`],
                itemUnit: data[`itemUnit_${i}`],
                manufacturingCountryName: manufacturingCountryList
                    ?.find((country: any) => country.value === data[`manufacturingCountry_${i}`])?.label,
                igst: data[`taxDetailsIgst_${i}`],
                sgst: data[`taxDetailsSgst_${i}`],
                cgst: data[`taxDetailsCgst_${i}`],
                taxDetailsRecieverGstin: data[`taxDetailsRecieverGstin_${i}`],
                taxDetailsSenderGstin: data[`taxDetailsSenderGstin_${i}`],
                forwardReferenceNumber: data[`forwardReferenceNumber_${i}`],
            });
        }
        return piecesDetail;
    };

    const referenceReplacer = (referenceObject: ReferenceObjectType, dataInput: DataInputType): ReferenceObjectType => {
        const newRefObj = lodash.cloneDeep(referenceObject);
        const result = replaceReferenceInObject(newRefObj, dataInput);
        return result;
    };

    const getFilteredValidations = (validateAllFields: any) => {
        if (!formLayout) return true;
        const formLayoutDataToValidate = [];
        if (validateAllFields) {
            formLayoutDataToValidate.push(...formLayout);
        } else {
            formLayoutDataToValidate.push(formLayout[currentTabIndex]);
        }
        const fields = formLayoutDataToValidate.map(
            (layout: any) => layout?.sections?.map((section: any) => {
                const fieldsList = section?.fieldsList ?? [];
                return fieldsList.map((field: string) => {
                    if (subLayout[field]) {
                        return [...(subLayout[field] || [])];
                    }
                    return field;
                }).flat();
            }).flat(),
        ).flat() ?? [];
        if (fields.includes('dimensions')) {
            fields.push('length', 'width', 'height');
        }
        if (fields.includes('address')) {
            fields.push(...addressTypes);
        }
        // eslint-disable-next-line
        for (const addressType of addressTypes) {
            if (fields.includes(addressType)) {
                // eslint-disable-next-line
                for (const field of addressFields) {
                    fields.push(
                        `${addressType}.${field}`,
                    );
                }
            }
        }
        const mappedFields = Object.keys(validationBuilderKeysMapping).filter((key) => {
            return fields.some((field: string) => key === field);
        }).map((key: string) => validationBuilderKeysMapping[key]);
        const isPieceValidationsEnabled = checkForPieceField(formLayoutDataToValidate) || validateAllFields;
        return validationData?.filter((data_: any) => {
            const condition = data_.filter.what || {};
            if (data_?.extraKeys?.keyIdentifier === 'piece' && !isPieceValidationsEnabled) {
                return false;
            }
            /* eslint-disable */
            for (const key of Object.keys(condition)) {
                if (key === '$or' || key === '$and') {
                    for (const subCondition of condition[key]) {
                    for (const orKey in subCondition) {
                        var trimmedKey = '';
                        if (orKey.startsWith('consignmentData.')) {
                            trimmedKey = orKey.replace('consignmentData.', '');
                        } else if (orKey.startsWith('piece.')) {
                            trimmedKey = orKey.replace('piece.', '');
                        }
                        if (trimmedKey && mappedFields.includes(trimmedKey)) {
                            return true;
                        }
                    }
                }
                } else {
                    var trimmedKey = '';
                    if (key.startsWith('consignmentData.')) {
                        trimmedKey = key.replace('consignmentData.', '');
                    } else if (key.startsWith('piece.')) {
                        trimmedKey = key.replace('piece.', '');
                    }
                    if (trimmedKey && mappedFields.includes(trimmedKey)) {
                        return true;
                    }
                }
            }
            return false;
        });
    }

    function validateDataUsingValidationBuilder(validateAllFields = false) {
        const formLayoutDataToValidate = [];
        if (validateAllFields) {
            formLayoutDataToValidate.push(...formLayout);
        } else {
            formLayoutDataToValidate.push(formLayout[currentTabIndex]);
        }
        const data = form.getFieldsValue();
        const piecesDetail = getPiecesDetail(data);
        const isPieceValidationsEnabled = checkForPieceField(formLayoutDataToValidate) || validateAllFields;
        if (isPieceValidationsEnabled) {
            const updatedFields = piecesDetail?.map((field: any) => {
                const updatedField: any = {};
                Object.keys(field)?.forEach((key): any => {
                    const mappedKey = validationBuilderKeysMapping[key];
                    updatedField[mappedKey || key] = field[key];
                });
                return updatedField;
            });
            data.piecesDetail = updatedFields;
        } else {
            data.piecesDetail = piecesDetail;
        }

        const filteredValidations = getFilteredValidations(validateAllFields);
        const formData = flattenObject(convertToAPIBodySaveSingle(data, { isCustomFieldAllowed: true, customFieldsList }));
        const dataFormatted: any = {
            consignmentData: {},
        };
        Object.keys(formData).forEach((key) => {
            if (validationBuilderKeysMapping[key]) {
                dataFormatted.consignmentData[validationBuilderKeysMapping[key]] = formData[key];
                if (formData[key] && intKeys.includes(validationBuilderKeysMapping[key])) {
                    dataFormatted.consignmentData[validationBuilderKeysMapping[key]] = +formData[key];
                }
            }
        });
        
        dataFormatted.consignmentData?.piecesDetail?.forEach((piece: any, index: number) => {
            Object.keys(piece).forEach((key) => {
                if (pieceLevelIntKeys.includes(key)) {
                    dataFormatted.consignmentData.piecesDetail[index][key] = piece[key] ? Number(piece[key]) : piece[key];
                }
            });
        });

        dataFormatted.consignmentData = unflattenObject(omitBy(dataFormatted.consignmentData, isEmptyValue));
        dataFormatted.piece = dataFormatted.consignmentData?.piecesDetail ? [ ...dataFormatted.consignmentData.piecesDetail ] : [];
        dataFormatted.piece = dataFormatted.consignmentData?.piecesDetail
            ? dataFormatted?.consignmentData?.piecesDetail?.map((piece: any) =>
                unflattenObject(omitBy(piece, isEmptyValue))
            )
            : [];
        let result = true;
        for (const data of filteredValidations) {
            let transformedWhenCondition = data?.filter?.when ?? {};
            transformedWhenCondition = referenceReplacer(transformedWhenCondition, dataFormatted);
            const siftedWhen = sift(transformedWhenCondition);
            if (siftedWhen(dataFormatted)) { //todo: add this condition to generic field
                let transformedWhatCondition = data?.filter?.what ?? {};
                transformedWhatCondition = referenceReplacer(transformedWhatCondition, dataFormatted);
                const sifted = sift(transformedWhatCondition);
                result = result && sifted(dataFormatted);
                if (!result) {
                    message.error(data.error);
                    break;
                }
            }

            if (Array.isArray(dataFormatted?.piece) && dataFormatted?.piece?.length) {
                const isMatchForEveryPiece = dataFormatted?.piece?.every((piece : any) => {
                    const pieceDataFormatted = { ...dataFormatted, piece };
                    let transformedPieceWhenCondition = data?.filter?.when ?? {};
                    transformedPieceWhenCondition = referenceReplacer(transformedPieceWhenCondition, pieceDataFormatted);
                    const siftedPieceWhen = sift(transformedPieceWhenCondition);
                    if (!siftedPieceWhen(pieceDataFormatted)) {
                        return true;
                    }
                    let transformedPieceWhatCondition = data?.filter?.what ?? {};
                    transformedPieceWhatCondition = referenceReplacer(transformedPieceWhatCondition, pieceDataFormatted);
                    const siftedPiece = sift(transformedPieceWhatCondition);
                    return siftedPiece(pieceDataFormatted);
                });
                result = result && isMatchForEveryPiece;
                if (!result) {
                    message.error(data.error);
                    break;
                }
            }
        }
        return result;
    }

    const checkCurrentPageErrors = async (addressTypeRadio?: string) => {
        setAddressErrors({});
        const errors: any = {};
        let hasAddressErrors = false;
        const fieldsToValidate = formLayout[currentTabIndex];
        const fields = fieldsToValidate?.sections?.map((section: any) => {
            const fieldsList = section?.fieldsList ?? [];
            return fieldsList.map((field: string) => {
                if (subLayout[field]) {
                    if (field === 'piece') {
                        const pieceFields = subLayout[field];
                        const arr: any = [];
                        pieceFields.forEach((pieceField: string) => {
                            if (pieceField === 'dangerousGood' || fieldNameToKeysMapping[pieceField]) {
                                const subKeys = pieceField === 'dangerousGood' ? subLayout['dangerous_good'] : fieldNameToKeysMapping[pieceField];
                                subKeys?.forEach((subKey: string) => {
                                    for (let i = 0; i < numberPieces; i++) {
                                        arr.push(`${subKey}_${i}`);
                                    }
                                })
                            }
                            else {
                                for (let i = 0; i < numberPieces; i++) {
                                    arr.push(`${pieceField}_${i}`);
                                }
                            }
                        });
                        return arr.flat();
                    }
                    return [...(subLayout[field] || [])];
                }
                return field in fieldNameToKeysMapping ? fieldNameToKeysMapping[field] : field;
            }).flat();
        }).flat() ?? [];
        if (fields.includes('address')) {
            if (addressTypeRadio) {
                fields.push(addressTypeRadio);
            } else {
                fields.push(...addressTypes);
            }
        }
        try {
            await form.validateFields(fields);
        } catch (error) {
            error.errorFields?.forEach((err: any) => {
                const fieldName = err.name[0];
                if (fieldName?.includes('Address')) {
                    errors[`${fieldName}Main`] = err.errors[0];
                }
            });
            setAddressErrors(errors);
            return false;
        }
        for (const addressType of addressTypes) {
            if (fields.includes(addressType) || fields.includes('address')) {
                const formValues = form.getFieldsValue([addressType]);
                const address = formValues[addressType] ? flattenObject(formValues[addressType]) : {};
                for (const field of addressFields) {
                    try {
                        await validateData(`${addressType}.${field}`, address[field] || '');
                    } catch (error) {
                        const errorMessage = error?.message;
                        errors[addressType] = errors[addressType]
                            ? `${errors[addressType]}, ${errorMessage}`
                            : errorMessage;
                        hasAddressErrors = true;
                    }
                }
            }
        }
        if (hasAddressErrors) {
            setAddressErrors(errors);
            return false;
        }
        return true;
    };

    const handleTabChange = async (tabIndex: number) => {
        // updateFormData();
        // await customCheck();
        if (tabIndex === currentTabIndex || creatingAddress) {
            return;
        }
        const inlineErrorsCheck = await checkCurrentPageErrors();
        if(!inlineErrorsCheck){
            return;
        }
        if (currentTabIndex === formLayout.length - 1 || validateDataUsingValidationBuilder()) {
            setCurrentTabIndex(tabIndex);
        }
    };

    const renderFilledCircle = (tabIndex: number) => {
        const activePage = tabIndex === currentTabIndex;
        return (
            <div
                className={activePage ? classes.filledCircle : classes.filledCircle}
            />
        );
    };

    const renderCircle = (tabIndex: number) => {
        const activePage = tabIndex === currentTabIndex;
        return (
            <div
                className={classes.tabIcon}
                style={{
                    border: activePage ? `2px solid ${uiTheme.primaryColor}`
                        : '2px solid #CCCCCC',
                    backgroundColor: activePage ? uiTheme.primaryColor : '#FFF',
                }}
            >
                {renderFilledCircle(tabIndex)}
            </div>
        );
    };

    const complete = () => {
        return (
            <CheckCircleFilled
                style={{
                    color: '#27B479',
                    fontSize: 24,
                }}
            />
        );
    };

    const inComplete = () => {
        return (
            <ExclamationCircleFilled
                style={{
                    color: '#EA2626',
                    fontSize: 24,
                }}
            />
        );
    };

    const completeIncompleteIcon = () => {
        const err = false;
        if (err) {
            return inComplete();
        }
        return complete();
    };

    const renderTabIcon = (tabIndex: number) => {
        if (tabIndex === currentTabIndex) {
            return renderCircle(currentTabIndex);
        }
        if (visited[tabIndex]) {
            return completeIncompleteIcon();
        }
        return renderCircle(tabIndex);
    };

    const renderTabDetails = (tabIndex: number) => {
        const activePage = tabIndex === currentTabIndex;
        return (
            <div
                style={{
                    color: activePage ? '#111111' : '#666666',
                    fontWeight: activePage ? 'bold' : 'normal',
                }}
            >
                <div
                    className={classes.tabName}
                >
                    {t(formLayout[tabIndex].prettyName)}
                </div>
            </div>
        );
    };

    const renderTab = (tabData: any, tabIndex: number) => {
        const activePage = tabIndex === currentTabIndex;
        return (
            <div
                key={tabIndex}
                className={classes.tabSelector}
                onClick={() => handleTabChange(tabIndex)}
                style={{
                    borderBottom: activePage
                        ? `4px solid ${uiTheme.secondryColor}` : 'none',
                }}
            >
                {renderTabIcon(tabIndex)}
                {renderTabDetails(tabIndex)}
            </div>
        );
    };

    const renderPageSelector = () => {
        return (
            <div className={classes.pageSelector}>
                {formLayout.map(renderTab)}
            </div>
        );
    };

    // Function to process all files and upload them to S3
    const processAndUploadFiles = async (documentDetails: any[]): Promise<DocumentDetailsUploadPayload[]> => {
        try {
            const newFileList: any = [];
            documentDetails?.forEach((data: any, index: number) => {
                let newFiles = data?.new_files_uploaded || [];
                const documentType = data?.document_type;
                newFiles = newFiles?.map((newFile: any) => {
                    return {
                        ...(newFile || {}),
                        document_type: documentType,
                        index,
                    };
                });
                newFileList?.push(...(newFiles || []));
            });

            
            const promises = newFileList?.map(async (file: any) => {
                const bodyGetUrl = {
                    content_type: file?.type,
                };

                const response = await getUploadFileUrls(bodyGetUrl);
                const upload = await uploadImageToS3(
                    new Blob([file?.originFileObj as BlobPart], {
                        type: file?.type,
                    }),
                    response?.data?.result?.imageSignedUrl,
                    file?.type,
                );
                const s3UrlToReturn = upload?.isSuccess ? response?.data?.result?.imageUrl : null;
                return {
                    url: s3UrlToReturn,
                    document_type: file?.document_type,
                    index: file?.index,
                    isSuccess: !!upload?.isSuccess,
                };
            });

            const fileUrls = await Promise.all(promises);
            const anyFailed = fileUrls?.some((file) => !file?.isSuccess);
            if (anyFailed) {
                return [];
            }
            const newlyUploaded = fileUrls?.filter((file: any) => !!file.url);
            const newlyUploadedFiles = groupBy(newlyUploaded, 'index');

            // Generating api payload for each document type
            const documentDetailsToUpload: DocumentDetailsUploadPayload[] = [];

            documentDetails?.forEach((data: any, index: number) => {
                const documentType = data?.document_type;
                if (documentType) {
                    const newFileObjects = newlyUploadedFiles[index] || [];
                    newFileObjects?.forEach((file) => {
                        documentDetailsToUpload?.push({
                            type: documentType,
                            url: file?.url,
                        });
                    });
                }
            });
            
            return documentDetailsToUpload;
        } catch (error) {
            return [];
        }
    };

    async function checkForErrors() {
        try {
            const formValues = await form.validateFields();
            const data = form.getFieldsValue();
            const piecesDetail = getPiecesDetail(data);
            const updatedData = {
                ...formValues,
            };
            let isPoValid = true;
            if (isPieceEnabled) {
                updatedData.piecesDetail = piecesDetail;
                piecesDetail.forEach((piece: any, index: number) => {
                    if (validatePiecePurchaseOrder && piece.purchase_order_number && !form.getFieldValue(`valid_purchaseOrderNumber_${index}`)) {
                        message.error('Please validate Purchase Order Number');
                        isPoValid = false;
                        return;
                    }
                });
            }
            if (!isPoValid) {
                return;
            }
            if (isPieceEnabled) {
                updatedData.numberOfPieces = piecesDetail?.length;
            }
            if (validateDataUsingValidationBuilder(true)) {
                setCreating(true);
                
                // Check if there are any files to upload
                const documentUploadField = form.getFieldValue('documentDetails');
                let documentDetailsToUpload: DocumentDetailsUploadPayload[] = [];
                
                if (Array.isArray(documentUploadField) && documentUploadField.length > 0) {
                    // Process and upload files if there are any
                    documentDetailsToUpload = await processAndUploadFiles(documentUploadField);
                    
                    // Update the form data with the S3 URLs
                    if (documentDetailsToUpload?.length > 0) {
                        updatedData.documentDetails = documentDetailsToUpload;
                    }

                    if (!documentDetailsToUpload?.length) {
                        message.error('Failed to upload documents. Remove the attached documents or try again later.');
                        setCreating(false);
                        return;
                    }
                }
                
                const apiBody = convertToAPIBodySaveSingle(updatedData, {
                    editData,
                    showRiskSurchargeType,
                    isCustomFieldAllowed: true,
                    customFieldsList,
                    isCodFieldPresent,
                    source: 'CUSTOMER_PORTAL_SINGLE_V2',
                });
                const response = await createConsignment(apiBody);
                if (response.isSuccess) {
                    loadconsignments();
                    setSuccess({
                        ...(response?.data || []),
                        showInvoicePrint: showInvoiceOptions
                            && updatedData.consignmentCategory === 'international'
                            && updatedData.courierType === 'non-document',
                    });
                } else {
                    message.error(response.errorMessage);
                }
                setCreating(false);
            }
        } catch (e) {
            message.error('Some fields are incomplete / invalid');
        }
    }

    async function handleAction(action: ButtonAction) {
        switch (action) {
            case ButtonAction.PREV: return setCurrentTabIndex(currentTabIndex - 1);
            case ButtonAction.NEXT:
                const inlineErrorsCheck = await checkCurrentPageErrors();
                if (!inlineErrorsCheck) {
                    return;
                }
                if (validateDataUsingValidationBuilder()) {
                    return setCurrentTabIndex(currentTabIndex + 1);
                }
                return null;
            case ButtonAction.SUBMIT: return checkForErrors();
            default: return null;
        }
    }

    const renderButton = (name: string, action: ButtonAction) => {
        return (
            <Button
                type="link"
                disabled={creatingAddress}
                onClick={() => handleAction(action)}
                loading={creating}
                className={classes.nextPreButton}
            >
                {action === ButtonAction.PREV && <LeftOutlined />}
                {name}
                {action === ButtonAction.NEXT && <RightOutlined />}
            </Button>
        );
    };

    const renderSubmitButton = () => {
        return (
            <Button
                type="primary"
                disabled={creatingAddress}
                onClick={() => handleAction(ButtonAction.SUBMIT)}
                loading={creating}
                className={classes.newButton}
            >
                {t(ButtonNames.SUBMIT)}
            </Button>
        );
    };

    const renderLeftButton = () => {
        if (currentTabIndex > 0) {
            return renderButton(t(ButtonNames.PREV), ButtonAction.PREV);
        }
        return <></>;
    };

    const renderRightButton = () => {
        if (currentTabIndex < (formLayout?.length) - 1) {
            return renderButton(t(ButtonNames.NEXT), ButtonAction.NEXT);
        }
        return renderSubmitButton();
    };

    const renderFooter = () => {
        return (
            <div className={classes.footer}>
                <div style={{
                    display: 'flex',
                    flex: 1,
                    justifyContent: currentTabIndex > 0 ? 'space-between' : 'flex-end',
                }}
                >
                    {renderLeftButton()}
                    {renderRightButton()}
                </div>
            </div>
        );
    };

    const renderCloseConfirmModal = () => {
        return (
            <Modal
                title={(
                    <div style={{ fontWeight: 600 }}>
                        <ExclamationCircleFilled style={{ color: '#EA2626', fontSize: 16 }} />
                        &nbsp;
                        {t('Confirm Action')}
                    </div>
                )}
                visible={closeConfirm}
                onCancel={() => setCloseConfirm(false)}
                footer={[
                    <Button key="back" type="text" onClick={() => setCloseConfirm(false)}>
                        {t('No, Continue')}
                    </Button>,
                    <Button key="submit" type="primary" onClick={onClose}>
                        {t('Yes, Cancel')}
                    </Button>,
                ]}
            >
                { i18n.exists('exit_cn_create_form')
                    ? t('exit_cn_create_form')
                    : ('Exiting will result in unsaved changes to your consignment creation.'
                    + ' Do you want to cancel adding consignment now?')}
            </Modal>
        );
    };

    const renderHeader = () => {
        return (
            <div className={classes.header}>
                <div className={classes.flexRow}>
                    <Cross onClick={() => setCloseConfirm(true)} alt="close" className={classes.closeIcon} />
                    <span>{editData ? 'Edit Consignment' : t('add_consignment')}</span>
                </div>
                {/* {renderButton(t(ButtonNames.SUBMIT), ButtonAction.SUBMIT)} */}
            </div>
        );
    };

    const isRequired = (isPiece: any, key: string) => {
        const isFTL = actionType === CreateActions.FTLHyperlocal;
        let required = false;
        if (isPiece) {
            required = required || mandatoryPieceDetails[key];
        } else {
            if (consignmentCategory === 'international') {
                required = [
                    formFields.Weight.key,
                    formFields.DeclaredValue.key,
                    formFields.CustomerReference.key,
                ].includes(key);
            }
            if (consignmentCategory === 'international' && itemType === 'non-document') {
                required = required || mandatoryFieldNonDocIntl[key];
            }
            if (consignmentCategory === 'international' && form.getFieldValue('shipmentPurpose') === 'COMMERCIAL') {
                required = required || mandatoryFieldShipmentCommercial[key];
            }
        }
        if (isFTL) {
            required = [
                formFields.MovementType.key,
                formFields.VehicleCategory.key,
            ].includes(key);
        }
        return required;
    };

    const getSummarySections = () => {
        const sections: any[] = [];
        formLayoutConfig?.forEach((pageData: any, index: number) => {
            pageData?.sections?.forEach((section: any) => {
                if (section.prettyName === SECTION_NAMES.SCHEDULE_DETAILS && !pickup_schedule_creation) {
                    return;
                }
                sections.push({
                    ...section,
                    fieldsList: section.fieldsList.filter((field: string) => {
                        if ((!ifFieldExistsInMapping(field, enableServiceability) ) && (!customFieldsList?.some((customField: any) => customField?.id === field))) {
                            return false;
                        } else if (consignmentCategory === 'domestic' && internationalFields.includes(field)) {
                            return false;
                        } else if (courierType === 'non-document' && nonDocumentFields.includes(field)) {
                            return false;
                        } else {
                            return true;
                        }
                    }),
                    goTo: index,
                });
            });
        });
        return sections;
    };

    const getFieldValidations = (key: any, isPieceLevel = false) => {
        const relationKeys = ['$eq', '$ne', '$gt', '$gte', '$lt', '$lte'];
        const filteredValidations = getFilteredValidations(true);
        const mappedKey = validationBuilderKeysMapping[key];
        const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
        if (mappedKey) {
            return filteredValidations.filter((val: any) => {
                const condition = val?.filter?.what || {};
                const when = val?.filter?.when || {};
                if (Object.keys(when).length === 0) {
                    for (const key in condition) {
                        if (key === '$or' || key === '$and') {
                            for (const subCondition of condition[key]) {
                                if (Object.keys(subCondition).some(sub => sub !== `${sourceKey}.${mappedKey}`)) {
                                    return false;
                                }
                                for(const con of Object.values(subCondition)) {
                                    for (const relation of relationKeys) {
                                        if (con?.[relation]?.$reference) {
                                            return false;
                                        }
                                    }
                                }
                            }
                            return true;
                        } else if (key === `${sourceKey}.${mappedKey}`) {
                            for (const relation of relationKeys) {
                                if (condition[key]?.[relation]?.$reference) {
                                    return false;
                                }
                            }
                            return true;
                        }
                    }
                }
                return false;
            });
        }
    }

    const isNinCondition = (condition: any) => {
        return condition?.$nin && Array.isArray(condition.$nin) &&
            condition.$nin.length === 4 &&
            condition.$nin.includes(null) &&
            condition.$nin.includes("") &&
            condition.$nin.includes(0);
    };

    const getIsRequiredValidation = (key: string, isPieceLevel = false) => {
        const mappedKey = validationBuilderKeysMapping[key];
        const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
        if (mappedKey) {
            const validation = getFieldValidations(key, isPieceLevel);
            for (const data of validation) {
                let transformedWhatCondition = data?.filter?.what ?? {};
                const condition = transformedWhatCondition[`${sourceKey}.${mappedKey}`] || {};
                if (isNinCondition(condition)) {
                    return true;
                };
            }
        }
        return false;
    };

    const validateData = async (key: string, value: string, isPieceLevel = false) => {
        const mappedKey = validationBuilderKeysMapping[key];
        if (mappedKey) {
            const sourceKey = isPieceLevel ? 'piece' : 'consignmentData';
            const validation = getFieldValidations(key, isPieceLevel);
            let cnData: any = {
                [sourceKey]: {
                    [mappedKey]: value,
                }
            };
            if ((isPieceLevel && pieceLevelIntKeys.includes(mappedKey))
                || (!isPieceLevel && intKeys.includes(mappedKey))) {
                cnData[sourceKey][mappedKey] = value ? +value : undefined;
            }
            cnData = unflattenObject(flattenObject(cnData));
            for (const data of validation) {
                let transformedWhatCondition = data?.filter?.what ?? {};
                transformedWhatCondition = referenceReplacer(transformedWhatCondition, cnData);
                const sifted = sift(transformedWhatCondition);
                if (!sifted(cnData)) {
                    return Promise.reject(new Error(data.error));
                }
            }
        }
        return Promise.resolve();
    };

    const getValidationRules = (fieldData: any, isPieceLevel = false, props: any = {}) => {
        const formRuleRequired = {
            ...formRules.required,
            message: i18n.exists('required') ? t('required') : 'Required',
        };
        const rulesList: any[] = [];
        if (isRequired(isPieceLevel, fieldData.key)) {
            rulesList.push(formRuleRequired);
        }
        if (props.MAX_LIMIT === 100 && fieldData.inputType === 'number') {
            rulesList.push(formRules.maxNumber100);
        }
        if (props.MAX_LIMIT === 1000 && fieldData.inputType === 'number') {
            rulesList.push(formRules.maxNumber1000);
        }
        rulesList.push({
            validator: async (_: any, value: any) => {
                return await validateData(fieldData.key, value, isPieceLevel);
            },
        });
        return rulesList;
    };

    const renderPage = (pageData: any, pageIndex: number) => {
        if(pageData.prettyName === 'summary' && currentTabIndex === pageIndex) {
            const data = form.getFieldsValue();
            const piecesDetail = getPiecesDetail(data);
            if (isPieceEnabled) {
                data.piecesDetail = piecesDetail;
            }
            const formData = flattenObject(convertToAPIBodySaveSingle(data, { isCustomFieldAllowed: true, customFieldsList }));
            formData.isCOD = data.isCOD;
            formData.childClient = data.childClient;
            formData.manufacturingCountryName = manufacturingCountryList.find((country: any) => country.value === data.manufacturingCountry)?.label;
            return (
                <div style={{ display: currentTabIndex === pageIndex ? 'block' : 'none' }}>
                    <SummaryStep
                        formData={formData}
                        sections={getSummarySections()}
                        handleTabChange={handleTabChange}
                        customFieldsList={customFieldsList}
                    />
                </div>
            );
        }
        if (pageData) {
            const { sections = [] } = pageData;
            return (
                <div style={{ display: currentTabIndex === pageIndex ? 'block' : 'none' }}>
                    {sections.map((section: any, sectionIndex: number) => {
                          if (section.prettyName === SECTION_NAMES.SCHEDULE_DETAILS && !pickup_schedule_creation) {
                            return null;
                        }
                        const { fieldsList = [] } = section;
                        return (
                            <>
                                <div className={classes.box}>
                                    <div className={classes.boxTitle}>
                                        <span>{section.prettyName}</span>
                                    </div>
                                    <div className={classes.boxFieldsCol}>
                                        <Row gutter={20}>
                                            {fieldsList.map((fieldId: string) => getFormFieldFromMapping(fieldId, form, {
                                                childClients,
                                                numberPieces,
                                                setNumberPieces,
                                                pudoHubs,
                                                categoryList,
                                                contentList,
                                                itemUnits,
                                                currencyList,
                                                countryList,
                                                incotermsList,
                                                isRequired,
                                                shipmentPurposeList,
                                                loadTypeList: loadType,
                                                isCurrentTab: currentTabIndex === pageIndex,
                                                isFTL: actionType === CreateActions.FTLHyperlocal,
                                                currentCustomField: customFieldsList.filter((field: any) => field.id === fieldId),
                                                customFieldsList,
                                                key: fieldId,
                                                isPieceEnabled,
                                                placeholderNumPieces,
                                                isDisabledNumPiece,
                                                manufacturingCountryList,
                                                fetchPoDetails,
                                                productCodeLists,
                                                resetProductCode,
                                                showProductCodeDropdown: show_product_code_dropdown,
                                                productHsCodeMapping,
                                                getValidationRules,
                                                getIsRequiredValidation,
                                                showDeclaredCurrencyField: fieldsList.find((field: string) => field === 'declaredCurrency'),
                                                addressErrors,
                                                checkErrorOnAddressChange: checkCurrentPageErrors,
                                                productCodeActive,
                                                disabledFields,
                                                setDisabledFields,
                                            },enableServiceability, setCreatingAddress))}
                                        </Row>
                                    </div>
                                </div>
                                {
                                    sectionIndex < sections.length - 1 ? (
                                        <div
                                            style={{
                                                height: 1,
                                                margin: '12px 0px',
                                                width: '100%',
                                                backgroundColor: '#EDEDED',
                                            }}
                                        />
                                    ) : <></>
                                }
                            </>
                        );
                    })}
                </div>
            );
        }
        return <></>;
    };

    const renderPages = () => {
        const pages = [...(formLayout || [])];
        return pages.map(renderPage);
    };

    return (
        <Drawer
            visible
            width="80%"
            title={renderHeader()}
            footer={renderFooter()}
            onClose={() => setCloseConfirm(true)}
            className={classes.main}
            closable={false}
            footerStyle={{
                padding: 0,
                margin: 0,
            }}
        >
            { loading ? <Loader /> : <></> }
            <Form form={form} className={classes.form}            >
                {renderPageSelector()}
                {renderPages()}
                {renderCloseConfirmModal()}
            </Form>
        </Drawer>
    );
};
const mapStateToProps = (state: ReduxStore) => {
    const { master } = state;
    const { config, Customer, properties } = master;
    const customerPortalConfig: any = config?.customer_portal_config;
    const shipmentPurposeList: any = config?.shipment_purpose_list;
    const mandatoryFieldNonDocIntl = customerPortalConfig?.mandatory_field_non_document_international || {};
    const mandatoryFieldShipmentCommercial = customerPortalConfig?.mandatory_shipment_commercial || {};
    const mandatoryPieceDetails = customerPortalConfig?.mandatory_piece_details || {};
    const showRiskSurchargeType = customerPortalConfig?.show_risk_surcharge_type;
    const showInvoiceOptions = Customer?.show_invoice_options;
    const useCategory = config?.use_category_in_commodity_data;
    const formLayoutConfig = config?.customer_portal_order_creation_config?.form_layout || [];
    const subLayout = config?.customer_portal_order_creation_config?.sub_layout || {};
    const customFieldsList = config?.custom_fields_list_for_form || [];
    const pickup_schedule_creation = properties?.pickup_schedule_creation;
    const show_product_code_dropdown = properties?.show_product_code_dropdown;
    const validatePiecePurchaseOrder = master.config?.validate_piece_purchase_order_number || false;
    return {
        uiTheme: state.uiTheme,
        mandatoryFieldNonDocIntl,
        mandatoryFieldShipmentCommercial,
        mandatoryPieceDetails,
        showRiskSurchargeType,
        showInvoiceOptions,
        useCategory,
        formLayoutConfig,
        shipmentPurposeList,
        subLayout,
        customFieldsList,
        pickup_schedule_creation,
        show_product_code_dropdown,
        autoCalculateDetails: customerPortalConfig?.auto_calculate_single_cn_fields_international,
        enableServiceability: customerPortalConfig?.enable_serviceability,
        validatePiecePurchaseOrder,
    };
};

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectRouter: true,
    connectTranslession: true,
};


export default withStyles(singleConsignmentStyles)(GenericHoc(hocConfig)(SingleConsignment));
